import React from "react";

const ProblemSolution = ({ problems, solutions }) => {
	return (
		<section className="problem-solution">
			<div className="container">
				<div className="problem">
					<h2>Problem</h2>
					{problems && problems.map((problem, key) => (
						<p key={key} dangerouslySetInnerHTML={{__html: problem}}></p>
					))}
				</div>
				<div className="solution">
					<div>
						<h2>Solution</h2>
						{solutions && solutions.map((solution, key) => (
							<p key={key} dangerouslySetInnerHTML={{__html: solution}}></p>
						))}
					</div>
				</div>
			</div>
		</section>
	);
}

export default ProblemSolution;